export default "__VITE_ASSET__f11218e4__"